<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-12 18:29:08
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-24 17:28:30
 * @FilePath: /dsicm-admin-web/src/layout/ContainerView.vue
-->
<template>
  <div>
    <el-container>
      <LeftMenu></LeftMenu>
      <Container></Container>
    </el-container>
  </div>
</template>

<script>
import LeftMenu from './LeftMenu';
import Container from './Container';
export default {
    components: {
      LeftMenu,
      Container
    },
    data() {
      return {
        
      };
    },
}
</script>

<style lang="less" scoped>
.el-container{
  height: 100vh;
  // padding: 0 !important;
  .el-container{
    background: #F8F8F8;
    position: relative;
    overflow: auto;
  }
}
</style>